angular.module('paymentmethods', ['core'])
    .factory('PaymentMethod', function ($resource) {
        return $resource('/crm/api/payment-methods/:id', {}, {
            list: {method: 'GET'},
            get: {method: 'GET'},
            table: {method: 'GET', isArray: false, url: '/crm/api/payment-methods/table'},
            autocomplete: {method: 'GET', isArray: true},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'}
        });
    })
    .service('PaymentMethodService', function ($rootScope, modals, PaymentMethod, $filter) {
        this.add = () => {
            let entity = {
                active: true,
                id: null
            };
            return editModal(entity);
        };
        this.edit = id => {
            PaymentMethod.get({id: id}, entity => editModal(entity));
        }
        this.remove = item => {
            return modals.confirmDelete($filter("localized")(item.name), () => PaymentMethod.delete({id: item.id}, () => $rootScope.$broadcast('paymentmethod.updated')).$promise);
        };

        function editModal(entity) {
            return modals.open('app/payment-method/edit-modal.html', 'PaymentMethodDialogController', entity, {size: 'md'}, "$ctrl");
        }
    })
    .component('paymentMethodList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/payment-method/list.html',
        controller: function ($scope, $state, $stateParams, PaymentMethod, PaymentMethodService) {
            this.PaymentMethodService = PaymentMethodService;
            this.reset = () => this.filters = {};

            $scope.$on('paymentmethod.updated', () => $state.reload());
        }
    })
    .controller('PaymentMethodDialogController', function ($timeout, $scope, $rootScope, $uibModalInstance, data, toastr, PaymentMethod) {
        this.item = data;
        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        this.save = () => {
            let promise;
            if (this.item.id !== null) {
                promise = PaymentMethod.update(this.item).$promise;
            } else {
                promise = PaymentMethod.save(this.item).$promise;
            }
            return promise.then(result => {
                $rootScope.$broadcast('paymentmethod.updated');
                $uibModalInstance.close(result);
                toastr.success("Zapisano");
            });
        };
    })
    .config(function ($stateProvider) {
        $stateProvider.state('paymentMethodList', {
            parent: 'app',
            url: '/payment-method?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': "paymentMethodList"
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (PaymentMethod, $q, $stateParams) => PaymentMethod.table(angular.copy($stateParams)).$promise
            }
        });
    });
